module.exports = "/_next/static/images/dd1267d4bf84625fc76176c05e1394aa-nubank-outdoor-lg@2x.jpg.webp";